import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { useShowNonMarketingStatus } from 'automation-ui-management/hooks/authHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkippedEnrollmentRow = ({
  skippedEnrollment,
  openTroubleshootEnrollmentPanel
}) => {
  const showNonMarketingStatus = useShowNonMarketingStatus(skippedEnrollment.objectTypeId);
  const {
    objectId,
    timestamp
  } = skippedEnrollment;
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx(UITableHoverCell, {
      hoverContent: /*#__PURE__*/_jsx(UITableHoverContent, {
        children: /*#__PURE__*/_jsx(UIButton, {
          size: "extra-small",
          use: "tertiary-light",
          onClick: () => {
            openTroubleshootEnrollmentPanel({
              objectId,
              timestamp
            });
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.panel.skipped-enrollments.table.troubleshoot"
          })
        })
      }),
      className: 'p-left-10',
      tooltip: false,
      children: /*#__PURE__*/_jsx(UIFlex, {
        direction: "column",
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: () => {
            openTroubleshootEnrollmentPanel({
              objectId,
              timestamp
            });
          },
          children: /*#__PURE__*/_jsx(ObjectNameReference, {
            id: objectId,
            objectTypeId: skippedEnrollment.objectTypeId,
            showNonMarketingStatus: showNonMarketingStatus,
            showMergeStatus: true,
            mergeAuditCutoff: timestamp,
            disableTruncateString: false,
            href: null
          })
        })
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
        value: timestamp,
        useMultiline: true
      })
    })]
  });
};
export default SkippedEnrollmentRow;